import { render, staticRenderFns } from "./SidebarAccordion.vue?vue&type=template&id=7afddb98&scoped=true"
import script from "./SidebarAccordion.vue?vue&type=script&lang=js"
export * from "./SidebarAccordion.vue?vue&type=script&lang=js"
import style0 from "./SidebarAccordion.vue?vue&type=style&index=0&id=7afddb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afddb98",
  null
  
)

export default component.exports